import RealTimeCustomerProfile from '@spectrum-icons/workflow/RealTimeCustomerProfile';
import React from 'react';

/**
 * Round avatar image, or the default profile glyph when there's no URL.
 * `alt` defaults to empty because every caller sits inside a control or next
 * to a visible name that already labels it.
 */
export function AvatarImage({ avatarUrl, size, alt = '' }) {
    if (avatarUrl) {
        return (
            <img
                src={avatarUrl}
                alt={alt}
                style={{
                    borderRadius: '50%',
                    width: size,
                    height: size,
                    objectFit: 'cover',
                }}
            />
        );
    }
    return <RealTimeCustomerProfile UNSAFE_style={{ width: size, height: size }} />;
}
